import React from "react";

export default function DeleteConfirmModal({
  open,
  title = "⚠️ Confirm Delete",
  itemType = "item",
  itemName = "Item Name",
  message = "",
  onCancel,
  onConfirm,
  confirmText = "🗑️ Delete",
  cancelText = "Cancel",
  confirmDisabled = false,
  confirmClassName = "btn btn-danger"
}) {
  if (!open) return null;

  return (
    <div className="modal-overlay active" onClick={onCancel} role="dialog" aria-modal="true">
      <div className="modal modal-sm" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>{title}</h3>
          <button className="modal-close" type="button" onClick={onCancel}>
            ✕
          </button>
        </div>
        <div className="modal-body">
          <div className="delete-confirm-body">
            {message ? null : <div className="delete-icon">🗑️</div>}
            {message ? (
              <p>{message}</p>
            ) : (
              <>
                <h4>Delete this {itemType}?</h4>
                <p>
                  Are you sure you want to delete "<strong>{itemName}</strong>"? This action cannot be undone.
                </p>
              </>
            )}
          </div>
        </div>
        <div className="modal-footer center">
          <button className="btn btn-outline" type="button" onClick={onCancel} disabled={confirmDisabled}>
            {cancelText}
          </button>
          <button className={confirmClassName} type="button" onClick={onConfirm} disabled={confirmDisabled}>
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
}
